import { useCreate, useDelete, useDetail, useList, useUpdate } from '@inmagik/react-crud'
import { fetchApi, useDataFetchingAuth } from '@inmagik/react-crud/dist/crud/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { API_URL } from '../constants'
import { Sede } from '../types'

export function useSediList(params: Record<string, string> = {}) {
  return useList<Sede>(`${API_URL}/bilance/sede`, params)
}

export function useSede(id: string) {
  return useDetail<Sede>(`${API_URL}/bilance/sede`, id, { enabled: !!id })
}

export function useCreateSede() {
  return useCreate<Sede>(`${API_URL}/bilance/sede`, {
    encode: 'formdata',
  })
}

export function useUpdateSede() {
  return useUpdate<Sede>(`${API_URL}/bilance/sede`, {
    encode: 'formdata',
  })
}

export function useDeleteSede() {
  return useDelete(`${API_URL}/bilance/sede`)
}

// #region AREA CLIENTI

export function useUploadDVR() {
  const client = useQueryClient()
  const authHeaders = useDataFetchingAuth()

  return useMutation({
    mutationFn: ({ sedeId, dvr }: { sedeId: Sede['id']; dvr: File }) => {
      const apiUrl = `${API_URL}/bilance/sede/${sedeId}/upload-dvr/`
      const fd = new FormData()
      fd.append('dvr', dvr)
      return fetchApi(apiUrl, {
        method: 'POST',
        headers: authHeaders,
        body: fd,
      })
    },
    onSuccess: (_result, variables) => {
      client.invalidateQueries({ queryKey: [`${API_URL}/bilance/sede`] })
      client.invalidateQueries({ queryKey: [`${API_URL}/bilance/sede`, variables.sedeId] })
    },
  })
}
